import { DataSourceItem } from '../recepts'
import renderDatetime from '../../../../../../helpers/tables/render-datetime'
import { ColumnsType } from 'antd/es/table'
import { Space } from 'antd'
import Edit from '../components/edit/edit'

export const columns: ColumnsType<DataSourceItem> = [
    {
        title: 'Номер заказа',
        dataIndex: 'receiptId',
        minWidth: 50,
        onCell: v => ({
            style: { verticalAlign: 'top' },
            rowSpan: v.rowSpan,
        }),
    },
    {
        title: 'Поставщик',
        dataIndex: ['supplier', 'name'],
        minWidth: 100,
        onCell: v => ({
            style: { verticalAlign: 'top' },
            rowSpan: v.rowSpan,
        }),
    },
    {
        title: 'Статус',
        dataIndex: 'receiptStatus',
        minWidth: 50,
        onCell: v => ({
            style: { verticalAlign: 'top' },
            rowSpan: v.rowSpan,
        }),
    },

    {
        title: 'Дата заказа',
        dataIndex: 'receiptCreatedAt',
        minWidth: 50,
        onCell: v => ({
            style: { verticalAlign: 'top' },
            rowSpan: v.rowSpan,
        }),
        render: (v: string) => {
            return v ? renderDatetime(v) : undefined
        },
    },

    {
        title: 'Дата прихода',
        dataIndex: 'receiptEstimatedDate',
        minWidth: 50,
        onCell: v => ({
            style: { verticalAlign: 'top' },
            rowSpan: v.rowSpan,
        }),
        render: (v: string) => {
            return v ? renderDatetime(v) : undefined
        },
    },
    /*     {
        title: 'Сумма',
        dataIndex: 'receiptSum',
        minWidth: 50,
        onCell: v => ({
            style: { verticalAlign: 'top' },
            rowSpan: v.rowSpan,
        }),
    }, */
    {
        title: 'Позиции заказа',
        children: [
            { title: 'Тип материала', dataIndex: ['material', 'material_type', 'name'] },
            { title: 'Ширина', dataIndex: ['material', 'width'], width: 70 },
            {
                title: 'Кол-во',
                dataIndex: 'amount',
                minWidth: 50,
                render: (value, record) => {
                    const unitName = record.unit ? record.unit.shortName : ''
                    return `${value} ${unitName}`
                },
            },
            {
                title: 'Ининциатор',
                minWidth: 150,
                render: (_, record) =>
                    record.initiator?.username ?? record.order_request?.initiator?.username,
            },
        ],
    },
    {
        title: 'Действия',
        fixed: 'right',
        width: 80,
        render: record => {
            return (
                <Space>
                    <Edit documentId={record.receiptDocumentId} />
                </Space>
            )
        },
        onCell: v => ({
            style: { verticalAlign: 'top' },
            rowSpan: v.rowSpan,
        }),
    },
]
